import React, { useEffect, useState } from 'react';
import { useLocalStorageState, useRequest } from 'ahooks';
import userApi from '@/api/userapi';
import md5 from 'md5';
import config from '@/config';
import PAGE from '@/constants/page';
import * as Cookie from '@/utils/cookie';
import { useHistory } from 'react-router';
import { Form, Input, Button, message } from 'antd';
import spider, { addTrack } from '@/business/spider';
import audiobookapi from '@/api/audiobookapi';
import './Signln.scss';

export default function SignIn(props) {
  const { updateOperate } = props;
  const history  = useHistory();
  const [errorInfo, setErrorInfo] = useState({});
  const { loading, runAsync: login } = useRequest(userApi.login, {
    manual: true
  });
  const [schoolType, setSchoolType] = useLocalStorageState('schoolType', {
    defaultValue: 1
  });

  useEffect(() => {
    setSchoolType(1);
  }, []);

  // 权限校验  // 大学生登录账号限制
  function jurisdiction(userName) {
    let isJurisdiction = true;
    if(config.env !== 'TEST') {
      if(ACCOUNT_ID.includes(Number(userName)) && Number(schoolType) === 1) {
        isJurisdiction = false;
      }
      if(!ACCOUNT_ID.includes(Number(userName)) && Number(schoolType) === 2) {
        isJurisdiction = false;
      }
    }
    return isJurisdiction;
  }

  const onFinish = async values => {
    const { userName, pwd } = values;
    const isJurisdiction = await jurisdiction(userName);
    if(userName && pwd) {
      // todo systemCode 暂时用编辑端的
      if(isJurisdiction) {
        Cookie.removeCookie(config.COOKIE, config.adviserDomain);
        login({ userName, pwd: md5(values.pwd), serveType: 'audio' }).then(({ token }) => {
          Cookie.saveCookie(token);
          message.success('登录成功');
          userApi.getUserInfo().then(res => {
            spider.setUserId(res.partyId);
            // addTrack('LOGIN', '4271', '7.0');
          });
          // 当前项目登录 通过接口获取empId
          audiobookapi.getEmployeeIdByAdviserIdAndJobId().then(res => {
            if(res) {
              localStorage.setItem('empId', res);
            } else {
              localStorage.setItem('empId', '');
            }
          });
          setTimeout(() => {
            // const cbPath = sessionStorage.getItem('cbPath');
            // history.replace(cbPath || PAGE.HOME);
            history.replace(PAGE.HOME);
          }, 100);
        }).catch(({ message }) => {
          setErrorInfo({
            status: 'error',
            message
          });
          // addTrack('LOGIN', '4272', '7.0');
          // message.error(message);
        });
      } else {
        // setErrorInfo({
        //   status: 'error',
        //   message: '该账号暂无权限'
        // });
        message.error('该账号暂无权限');
      }
    } else {
      setErrorInfo({
        status: 'error',
        message: '账号或密码错误'
      });
      // message.error('账号不存在');
    }
  };

  return (
    <div className="form-sign_in">
      <h3 className="form-title">账号登录</h3>
      <Form className="account-wrap" layout="vertical" onFinish={onFinish} onValuesChange={() => setErrorInfo({})}>
        <Form.Item
          label="手机号"
          name="userName"
          rules={[
            {
              required: true,
              message: '请输入手机号'
            }
          ]}
        >
          <Input className="input-wrap" placeholder="请输入手机号" />
        </Form.Item>
        <Form.Item
          label="密码"
          className="mb10"
          name="pwd"
          validateStatus={errorInfo.status}
          help={errorInfo.message}
          rules={[
            {
              required: true,
              message: '请输入密码'
            }
          ]}
        >
          <Input.Password className="input-wrap" placeholder="请输入密码" />
        </Form.Item>
        <div className="text-right mb30">
          <Button type="link" className="forget-pwd" onClick={() => updateOperate('FORGET')}>忘记密码</Button>
        </div>
        <Form.Item className="mb0">
          <Button size="large" style={{ fontSize: 16 }} type="primary" loading={loading} htmlType="submit" block>登录</Button>
        </Form.Item>
      </Form>
    </div>
  );
}

const ACCOUNT_ID = [18627089510];
